<template>
    <div>
        <div class="listingPageTitle">
            <h1>Survey Maintenance</h1>
            <ItemModal :itemName="'Survey'"
                            :formRows="newItemFormRows"
                            :saveItemFunction="saveRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'name'}" />
    </div>
</template>

<script>
import { data } from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'SurveyListing',
    components: { ItemModal, ListingTable },
    data: function() {
        return {
            surveys: [],
            searchText: '',
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Name",
                    width: "45%",
                    fieldName: "name",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Code",
                    width: "35%",
                    fieldName: "code"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive"
                }
            ],
            newItemFormRows: [
                {
                    name: 'Name',
                    propertyName: 'name',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Code',
                    propertyName: 'code',
                    required: true,
                    element: 'input'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                editHrefBuilder: this.editHrefBuilder
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "name",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllSurveys(this.searchText, false);
        },
        editHrefBuilder: function(sur) {
            return '/SurveyEdit?ID=' + sur.id + '&Code=' + sur.code;
        },
        deleteRecord: async function(sur) {
            if(confirm('Are you sure you want to delete this survey?')) {
                var status = this.processDeactivateResult(await data.deleteSurvey(sur.id));
                if(status.success) 
                    sur.isActive = false;
            }
        },
        saveRecord: async function(sur) {
            sur.languages = ["English"];
            sur.defaultLanguage = "English";
            return await this.saveSurvey(sur, true);
        },
        saveSurvey: async function(sur, redirectToEditFlag) {
            var retObject = this.processSaveResult(await data.saveSurvey(sur));

            if(retObject.success) {
                if(redirectToEditFlag && retObject.id) {
                    sur.id = retObject.id;
                    window.location.href = this.editHrefBuilder(sur);
                }
                else 
                    return retObject;
            }
            else
                return retObject;
        },
        reactivateRecord: async function(sur) {
            sur.isActive = true;
            var status = await this.saveSurvey(sur);
            if(!status.success)
                sur.isActive = false;
        }
    }
}
</script>

<style scoped>
    .searchContainer {
        text-align: left;
        margin: 20px 50px 25px;
    }
    .searchContainer .formRow {
        margin: 0px 0;
    }
    .inputTitle {
        padding-right: 15px;
       
    }
    .searchContainer button {
        height: 40px;
        width: 250px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        font-size: 16px;
        cursor: pointer;
    }
</style>